import React, { useEffect, useState, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import "../../assets/styles/local/TaskDelete.css";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import { handleGeneralNotification } from "../../utils/helpers/notifications";

const QuotesApprovedPopup = (props) => {
  const [fetchTransPlanBoadList, setFetchTransPlanBoadList] = useState({});
  const t = (key) => fetchTransPlanBoadList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Planboard-List").then((res) => {
      setFetchTransPlanBoadList(res);
    });
  }, []);

  return (
    <>
      <Modal
        id="asc"
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered>
        <div className="text-center">
          <div>
            <p className="firstHead pt- mb-4"
             style={{color:"#333333"}}
            >
              {/* {fetchTransPlanBoadList[18]?.translation}{" "} */}
              This quote has been approved previously.
            </p>
            <p className="firstHead m-0"
             style={{color:"#333333"}}
            >
              {/* {fetchTransPlanBoadList[19]?.translation} */}
              Do you want to proceed with the changes
            </p>
            <p className="proceed pt-1">
              {/* {fetchTransPlanBoadList[20]?.translation} */}
              and send for re-approval?
            </p>
          </div>

          <div className="d-flex justify-content-center flex-wrap gap-4 pt-5">
            <div className="btnNoDiv">
              <button className="btnNo p-2"
               // onClick={props.onHide}
               onClick={()=>{
                props.onHide();

                handleGeneralNotification({
                  notificationType: "CUSTOM",
                  text: `The changes on the quotes were discarded.`,
                });
               }}
              >
                {/* {fetchTransPlanBoadList[21]?.translation} */}
                Cancel
              </button>
            </div>

            <div className="btnYesDiv"
             style={{background:"#00246A", border:"1px solid #00246A"}}
            >
              {/* <button onClick={props.handleDelete}>yes</button> */}
              <button className="btnYes p-2" onClick={props.handleDelete}>
                {/* {fetchTransPlanBoadList[22]?.translation} */}
                Proceed
                {props.loading === true && (
                  <div
                    className="spinner-border spinner-border-sm ms-2"
                    role="status"></div>
                )}
              </button>
            </div>
          </div>
        </div>
      </Modal>

      {/* <Button variant="primary" onClick={handleShow}>
                Launch demo modal
            </Button>

            <Modal show={show} onHide={handleClose}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Modal heading</Modal.Title>
                </Modal.Header>
                <Modal.Body>Woohoo, you're reading this text in a modal!</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleClose}>
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal> */}
    </>
  );
};

export default QuotesApprovedPopup;
